import aws, { Credentials } from 'aws-sdk';
import {
  config
} from '../config';
const access = new Credentials({
  accessKeyId: config.AWS_ACCESS_KEY_ID,
  secretAccessKey: config.AWS_SECRET_KEY,
});

const amazonS3 = new aws.S3({
  endpoint: config.endpoint,
  credentials: access,
  region: config.REGION,
  signatureVersion: 'v4',
})

const getFileFromS3 =  (key: string, expires: number) => {
  const url =  amazonS3.getSignedUrl('getObject', {
      Bucket: config.BUCKET_NAME,
      Key: key,
      Expires: expires,
  })

  return url;
}

const getFileFromS32 = async (key: string, expires: number) => {
  const url = await amazonS3.getSignedUrlPromise('getObject', {
      Bucket: config.BUCKET_NAME,
      Key: key,
      Expires: expires,
  })

  return url;
}
export { getFileFromS3, getFileFromS32 }
